import React from 'react';
import PropTypes from 'prop-types';

const IconVehicle = props => {
  switch (props.name) {
    case 'icon_motorcycle':
      return (
        <span {...props} className={`icon-icon_motorcycle${props.className ? ` ${props.className}` : ''}`}/>
      );
    case 'icon_car':
      return <span {...props} className={`icon-icon_car${props.className ? ` ${props.className}` : ''}`} />;
    default:
      return null;
  }
};

IconVehicle.propTypes = {
  'className': PropTypes.string,
  'name': PropTypes.string,
};

export default IconVehicle;
